export const environment = {
  production: false,
  api_base_url: 'https://api.saffron-dev.meridianwise.com',
  app_title: 'Saffron Dev',
};
